import React from 'react';
import { useField } from 'formik';
import { TbAlertTriangleFilled } from 'react-icons/tb';
import classNames from 'classnames';

interface FormikNumberFieldProps {
  label: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  min?: number;
  max?: number;
}

const FormikNumberField: React.FC<FormikNumberFieldProps> = ({
  label,
  name,
  placeholder = '',
  disabled = false,
  className = '',
  min,
  max
}) => {
  const [field, meta] = useField(name);
  const { touched, error } = meta;
  const showError = Boolean(touched && error);
  const inputId = `${name}-input`;

  const handleChange = (e) => {
    field.onChange(e);
    // Keep focus on the field
    e.target.focus();
  };

  return (
    <div className={`${className}`}>
      <label
        htmlFor={inputId}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label}
      </label>
      <div className="relative">
        <input
          id={inputId}
          type="number"
          name={field.name}
          value={field.value}
          onChange={handleChange}
          onBlur={field.onBlur}
          disabled={disabled}
          placeholder={placeholder}
          min={min}
          max={max}
          className={classNames(
            'mt-1 block w-full px-4 py-3 text-base border focus:outline-none focus:ring-indigo-500 sm:text-sm rounded-md',
            showError
              ? 'border-red-800 focus:border-red-800'
              : 'border-gray-300 focus:border-indigo-500'
          )}
          style={{
            WebkitAppearance: 'none',
            MozAppearance: 'textfield',
            appearance: 'textfield',
            margin: 0,
            boxSizing: 'border-box'
          }}
        />
      </div>
      {showError && (
        <div className="mt-2 text-red-800 flex items-center gap-1 font-normal text-sm">
          <TbAlertTriangleFilled size={16} /> {error}
        </div>
      )}
    </div>
  );
};

export default FormikNumberField;
